import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ISysAdminDevicesData,
    SysAdminDevicesData,
} from "../../types/sysAdminInterface/sysAdminHomepageTypes"

export const sysAdminHomepageMapper = {
    /**
     * Maps the response from the SysAdmin Homepage API to the ISysAdminDevicesData interface.
     * @param response - The response from the API.
     * @returns The mapped object of type ISysAdminDevicesData.
     */
    mapSysAdminDevicesData: (response: unknown): ISysAdminDevicesData => {
        const res = tsIoValidate<ISysAdminDevicesData>(
            SysAdminDevicesData,
            response,
            "Error mapping Sys Admin Homepage Devices Data"
        )
        return res
    },
}
